import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import websiteComponent from '@/components/website'
const noFound = () => import('@/components/website/shared/noFound')

//-------------------------fee-history------------------------------------------------------------
const fee_history = () => import('@/components/website/fees/fee_history')
//-------------------------request_access----------------------------------------------------------------
const request_access = () => import('@/components/website/request/request_access')
//-------------------------task-list------------------------------------------------------------
const task_listing = () => import('@/components/website/task/task_listing')
//-------------------------manage-group------------------------------------------------------------
const group_listing = () => import('@/components/website/mange_group/group_listing')
const group_view = () => import('@/components/website/mange_group/group_view')
const group_add_edit = () => import('@/components/website/mange_group/group_add_edit')
//-------------------------pricing------------------------------------------------------------
const plan_listing = () => import('@/components/website/pricing/plan_listing')
const plan_view = () => import('@/components/website/pricing/plan_view')
const create_plan = () => import('@/components/website/pricing/create_plan')

const offer_listing = () => import('@/components/website/pricing/offer_listing')
const offer_view = () => import('@/components/website/pricing/offer_view')
const create_offer = () => import('@/components/website/pricing/create_offer')
const pricing_plan = () => import('@/components/website/pricing/pricing_plan')
//-------------------------reporting------------------------------------------------------------
const reportReporting = () => import('@/components/website/report/reporting')
const create_collateral_report = () => import('@/components/website/report/create_collateral_report')
const create_emir_report = () => import('@/components/website/report/create_emir_report')
const create_mifir_report = () => import('@/components/website/report/create_mifir_report')
const create_reporting_member_report = () => import('@/components/website/report/create_reporting_member_report')
//-------------------------coupon----------------------------------------------------------------
const couponListing = () => import('@/components/website/coupon/coupon_listing')
const createCoupon = () => import('@/components/website/coupon/create_coupon')
const subscriptionListing = () => import('@/components/website/coupon/subscription_listing')
const subscriptionDetail = () => import('@/components/website/coupon/subscription_detail')

//-----------------------NOTIFICATION LIST------------------------------------------------------
const notificationListing = () => import('@/components/website/notification/notification_listing')
//-------------------------admin----------------------------------------------------------------
const adminListing = () => import('@/components/website/admin/admin_listing')
const adminView = () => import('@/components/website/admin/admin_view')
const adminAdd = () => import('@/components/website/admin/create_admin')
//-------------------------email----------------------------------------------------------------
const emailListing = () => import('@/components/website/email/email_listing')
const createEmail = () => import('@/components/website/email/create_email')
//-------------------------client----------------------------------------------------------------
const clientListing = () => import('@/components/website/client/client_listing')
const logsView = () => import('@/components/website/client/logs_view')
const clientView = () => import('@/components/website/client/client_view')
const email_file = () => import('@/components/website/log/email_file')
//-----------------------------------------faq---------------------------------------------------
const faqCat = () => import('@/components/website/faq/create_category')
const faqArticle = () => import('@/components/website/faq/create_article')
const faqEditCat = () => import('@/components/website/faq/edit_category')
const faqEditArticle = () => import('@/components/website/faq/edit_article')
const catList = () => import('@/components/website/faq/category_listing')
const articleList = () => import('@/components/website/faq/article_listing')
//-------------------------admin-----------------------------------------------------------------
const adminLogin = () => import('@/components/website/admin/login')
const adminDashboard = () => import('@/components/website/admin/dashboard')
//-------------------------ticket-----------------------------------------------------------------
const createTicket = () => import('@/components/website/ticket/create_ticket')
const ticketListing = () => import('@/components/website/ticket/ticket_list')
const ticketView = () => import('@/components/website/ticket/ticket_view')

const internal_deposit_list = () => import('@/components/website/ticket/internal_deposit_list')
//-------------------------deposit---------------------------------------------------------------
const depositListing = () => import('@/components/website/deposit/deposit_listing')
const depositView = () => import('@/components/website/deposit/deposit_view')
const createDeposit = () => import('@/components/website/deposit/create_deposit')
const depositTransaction  = () => import('@/components/website/deposit/deposit_transaction')
//-------------------------bonus---------------------------------------------------------------
const bonusListing = () => import('@/components/website/bonus/bonus_listing')
const bonusView = () => import('@/components/website/bonus/bonus_view')
//-------------------------withdrawal------------------------------------------------------------
const createWithdrawal = () => import('@/components/website/withdrawal/create_withdrawal')
const withdrawalListing = () => import('@/components/website/withdrawal/withdrawal_listing')
const withdrawalListingAccount = () => import('@/components/website/withdrawal/withdrawal_account_list')
const withdrawalView = () => import('@/components/website/withdrawal/withdrawal_view')
//-------------------------trading-account-------------------------------------------------------
const createTrading = () => import('@/components/website/trading/create_trading')
const tradingListing = () => import('@/components/website/trading/trading_listing')
const tradingOrders= () => import('@/components/website/trading/trading-orders')
const tradingView = () => import('@/components/website/trading/trading_view')
//-------------------------search-list-------------------------------------------------------
const search = () => import('@/components/website/shared/search')
//-------------------------Useer PDF---------------------------------------------------------
const userPDF = () => import('@/components/website/client/pdf')
const notes = () => import('@/components/website/internal_notes/notes')

//-------------------------Reset Password---------------------------------------------------------

const resetPassword = () => import('@/components/website/shared/resetpassword')
const webHooks = () => import('@/components/website/web-hooks/web_hooks')

//-------------------------credit-cards---------------------------------------------------------------
const creditCardsMainUserListing = () => import('@/components/website/credit_cards/main_user_listing')
const creditCardsUserListing = () => import('@/components/website/credit_cards/user_listing')
const cardUserDetailView = () => import('@/components/website/credit_cards/user_detail')
const creditCardsTransactionListing = () => import('@/components/website/credit_cards/transaction_listing')

Vue.use(Router)
const router =  new Router({
	mode: 'history',
	routes: [
		//-------------------------admin-login--------------------------------------------------
		{ path: '/', name: 'admin.adminLogin', component: adminLogin },
		{ path: '/clientpdf', name: 'client.userPDF',  props : true, component: userPDF },
		
		{
			path:'/',
			component: websiteComponent,
			children:[
				//-------------------------credit-cards------------------------------------------------
				{ path: '/cards-individual-users', name: 'creditCardsMainUserListing',  component: creditCardsMainUserListing },
				{ path: '/cards-sub-users', name: 'creditCardsUserListing',  component: creditCardsUserListing },
				{ path: '/cards-user-wallets', name: 'cardUserDetailView',  component: cardUserDetailView },
				{ path: '/cards-transaction-listing', name: 'creditCardsTransactionListing',  component: creditCardsTransactionListing },
				//-------------------------fee-history------------------------------------------------
				{ path: '/fee-history', name: 'fees.fee_history',  component: fee_history },
				//-------------------------pricing------------------------------------------------
				{ path: '/plan-listing', name: 'pricing.plan_listing',  component: plan_listing },
				{ path: '/plan-view', name: 'pricing.plan_view',  props : true, component: plan_view },
				{ path: '/create-plan', name: 'pricing.create_plan',  component: create_plan },
				{ path: '/offer-listing', name: 'pricing.offer_listing',   component: offer_listing },
				{ path: '/offer-view', name: 'pricing.offer_view',  props : true, component: offer_view },
				{ path: '/create-offer', name: 'pricing.create_offer',   component: create_offer },
				{ path: '/pricing-plan', name: 'pricing.pricing_plan',   component: pricing_plan },
				//----------------------------------------------------------------------------------
				{ path: '/view-email', name: 'log.email_file',  props : true, component: email_file },
				{ path: '/not-found', name: 'noFound',  component: noFound },
				{ path: '/request-access', name: 'request.request_access',  component: request_access },
				//-------------------------task-list------------------------------------------------
				{ path: '/task-listing', name: 'task.task_listing',  component: task_listing },
				{ path: '/notes', name: 'internal_notes.notes',  props : true, component: notes },
				//-------------------------manage-group------------------------------------------------
				{ path: '/group-listing', name: 'mange_group.group_listing',  component: group_listing },
				{ path: '/group-view', name: 'mange_group.group_view',  component: group_view },
				{ path: '/add-edit', name: 'mange_group.group_add_edit',  component: group_add_edit },
				//-------------------------reporting------------------------------------------------
				{ path: '/coupon-listing', name: 'coupon.couponListing',  component: couponListing },
				{ path: '/create-coupon', name: 'coupon.createCoupon',  component: createCoupon },
				{ path: '/subscription-listing', name: 'coupon.subscriptionListing',  component: subscriptionListing },
				{ path: '/subscription-detail', name: 'coupon.subscriptionDetail',  component: subscriptionDetail },
				//-------------------------reporting------------------------------------------------
				{ path: '/reporting', name: 'report.reportReporting',  component: reportReporting },
				{ path: '/create-collateral-report', name: 'report.create_collateral_report',  component: create_collateral_report },
				{ path: '/create-emir-report', name: 'report.create_emir_report',  component: create_emir_report },
				{ path: '/create-mifir-report', name: 'report.create_mifir_report',  component: create_mifir_report },
				{ path: '/create-reporting-member-report', name: 'report.create_reporting_member_report',  component: create_reporting_member_report },
				//-------------------------admin------------------------------------------------
				{ path: '/search', name: 'shared.search',  component: search },

				{ path: '/notification-list', name: 'admin.notificationListing',  component: notificationListing },
				//-------------------------admin------------------------------------------------
				{ path: '/admin-list', name: 'admin.adminListing',  component: adminListing },
				{ path: '/admin-view',  name: 'admin.adminView', props : true, component: adminView },
				{ path: '/create-admin',  name: 'admin.adminAdd', props : true, component: adminAdd },
				//-------------------------email------------------------------------------------
				{ path: '/email-setting-list', name: 'email.emailListing',  component: emailListing },
				{ path: '/create-email',  name: 'email.createEmail', props : true, component: createEmail },
				//-------------------------client------------------------------------------------
				{ path: '/listing', name: 'client.clientListing',  component: clientListing },
				{ path: '/logs-view',  name: 'client.logsView', props : true, component: logsView },
				{ path: '/view',  name: 'client.clientView', props : true, component: clientView },
				
				//-------------------------faq---------------------------------------------------
				{ path: '/category',  name: 'faq.faqCat', props : true, component: faqCat },
				{ path: '/articles',  name: 'faq.faqArticle', props : true, component: faqArticle },
				{ path: '/edit-category',  name: 'faq.faqEditCat', props : true, component: faqEditCat },
				{ path: '/edit-article',  name: 'faq.faqEditArticle', props : true, component: faqEditArticle },
				{ path: '/category-list',  name: 'faq.catList', props : true, component: catList },
				{ path: '/articles-list',  name: 'faq.articleList', props : true, component: articleList },
				//-------------------------ticket------------------------------------------------
				{ path: '/create-ticket', name: 'ticket.createTicket',  component: createTicket },
				{ path: '/ticket-list', name: 'ticket.ticketListing',  component: ticketListing },
				{ path: '/ticket-view',  name: 'ticket.ticketView', props : true, component: ticketView },
				{ path: '/internal-deposit-list', name: 'ticket.internal_deposit_list',  component: internal_deposit_list },
				//-------------------------deposit-----------------------------------------------
				{ path: '/create-deposit',  name: 'deposit.createDeposit', props : true, component: createDeposit },
				{ path: '/deposit-list',  name: 'deposit.depositListing',  component: depositListing },
				{ path: '/deposit-view',  name: 'deposit.depositView', props : true, component: depositView },
				{  path: '/transaction-history',  name: 'deposit.depositTransaction',  component: depositTransaction },
				//-------------------------bonus-----------------------------------------------
				{ path: '/bonus-list',  name: 'bonus.bonusListing',  component: bonusListing },
				{ path: '/bonus-view',  name: 'bonus.bonusView', props : true, component: bonusView },
				//-------------------------withdrawal--------------------------------------------
				{ path: '/create-withdrawal', name: 'withdrawal.createWithdrawal',  component: createWithdrawal },
				{ path: '/withdrawal-list',  name: 'withdrawal.withdrawalListing', component: withdrawalListing },
				{ path: '/withdrawal-account-list',  name: 'withdrawal.withdrawalListingAccount', component: withdrawalListingAccount },
				{ path: '/withdrawal-view',  name: 'withdrawal.withdrawalView',  props : true, component: withdrawalView },
				//-------------------------trading-account---------------------------------------
				{ path: '/create-trading',  name: 'trading.createTrading', component: createTrading },
				{ path: '/trading-orders',   name: 'trading.tradingOrders', component: tradingOrders },
				{ path: '/trading-list',  name: 'trading.tradingListing', component: tradingListing },
				{ path: '/trading-view',  name: 'trading.tradingView', props : true, component: tradingView },
				//-------------------------admin-------------------------------------------------
				{ path: '/dashboard',   name: 'admin.adminDashboard',  component: adminDashboard },

				//-------------------------client------------------------------------------------

				{ path: '/reset-password',   name: 'admin.resetPassword',  component: resetPassword },
				{ path: '/web-hooks',   name: 'admin.webHooks',  component: webHooks },

			]
		}, 

		
		   
	]
})

router.beforeEach((to, from, next) => {

	if( to.name == 'admin.adminDashboard' || to.name == 'request.request_access' || to.name == 'task.task_listing' || to.name == 'internal_notes.notes' || to.name == 'admin.adminListing' || to.name == 'client.clientListing' || to.name == 'mange_group.group_listing' || to.name == 'admin.adminDashboard' || to.name == 'admin.adminDashboard' || to.name == 'admin.adminDashboard' || to.name == 'withdrawal.withdrawalListing' || to.name == 'withdrawal.withdrawalListingAccount' || to.name == 'deposit.depositListing' || to.name == 'trading.tradingListing' || to.name == 'ticket.internal_deposit_list' || to.name == 'ticket.ticketListing' || to.name == 'email.emailListing'   || to.name == 'admin.notificationListing'  ){
		localStorage.setItem("lastPath", to.path);

	}
	const userStateVariable = store.state.user
	//let permissionVariable = userStateVariable.permissions.split(',')
	//console.log(permissionVariable.indexOf('ADMIN_LIST'))
	if (to.name !== 'admin.adminLogin'   && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) next({ name: 'admin.adminLogin' })
	
	//else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == 'admin.adminListing' && permissionVariable.indexOf('ADMIN_LIST') >= 0) next({ name: 'admin.adminListing' })
	 
	//else if(userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == '' && ) next({ name: '' })
	
	else next()
	
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js